import { Toaster } from 'react-hot-toast';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Banner from './Components/Banner';
import Footer from './Components/Footer';
import Contact from './Pages/Contact';
import Home from './Pages/Home';

function App() {
  return (
    <div className="">
      {/* <Navbar/> */}
      <Banner />
      <Routes>
      <Route path='/' element={<Home></Home>}></Route>
      <Route path='/contact' element={<Contact></Contact>}></Route>
      </Routes>
      <Footer/>
      <Toaster />
    </div>
  );
}

export default App;
